export const NetworkContextName = "NETWORK";